import { render, staticRenderFns } from "./dynamicTargets.vue?vue&type=template&id=08132833&scoped=true"
import script from "./dynamicTargets.vue?vue&type=script&lang=js"
export * from "./dynamicTargets.vue?vue&type=script&lang=js"
import style0 from "./dynamicTargets.vue?vue&type=style&index=0&id=08132833&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08132833",
  null
  
)

export default component.exports